import React, { Component }               from 'preact';
import StorageContext                     from '../store/storage_context';
import ReCAPTCHA                          from 'react-google-recaptcha';
import Header                             from './layout/header';
import PageText                           from '../components/partials/page_text';
import FullStars                          from '../components/partials/full_stars';
import ReactDropdown                      from 'react-dropdown';
import { getSiteName }                    from '../utils/branding';
import { validateCreateReviewForm }       from '../utils/validation';
import { createReview } from '../api/review';
import { getPageMeta, getPortletGroups }  from '../api/branding';
import TopTips from '../components/partials/top_tips';
import { TG_WIDGET_REVIEW_SCHEMES } from '../config/keys';

interface ICreateReviewProps {
    avar?: number;
}

interface ICreateReviewState {
    payload: any;
    reviewScheme: any;
    success: boolean;
    recaptcha: string;
    recaptchaError: boolean;
    errors: any;
    submitting: boolean;
    typeValues: any;
    portletGroups: any;
    pageMeta: any;
    naRatingValue: any;
    loading: boolean;
    widgetThemeVariables: any;
    displayNameManuallySet: boolean;
    reviewSchemes: any;
    theme: any;
    serverSideErrors: any;
    showTopTips: boolean;
    showRecaptcha: boolean;
}

class CreateReview extends Component<ICreateReviewProps, ICreateReviewState> {

    private regExIsFieldNameInErrorMessage = new RegExp(/"([^"]+)"/);

    constructor (props: ICreateReviewProps) {
        super(props);

        this.state = {
            payload: this.initialPayload,
            reviewScheme: null,
            success: false,
            recaptcha: '',
            recaptchaError: false,
            errors: [],
            submitting: false,
            typeValues: {},
            portletGroups: getPortletGroups(),
            pageMeta: getPageMeta(),
            naRatingValue: null,
            loading: true,
            widgetThemeVariables: {},
            displayNameManuallySet: false,
            reviewSchemes: [],
            theme: {},
            serverSideErrors: [],
            showTopTips: false,
            showRecaptcha: false
        };
    }

    get initialPayload() {
        const payload: any = {
            ReviewRating: [],
            MemberID: 0,
            MemberCategoryID: null,
            ReviewSchemeID: 0,
            ReviewTitle: '',
            ReviewerFirstName: '',
            ReviewerLastName: '',
            ReviewerEmailAddress: '',
            ReviewerTelephoneNumber: '',
            ReviewerDisplayName: '',
            ReviewerConnectionID: null,
            ReviewContent: '',
            ExperienceTypeID: null,
            Cost: '',
            Theme: 'apfm',
            InviteToken: null,
            WebsiteUserID: null,
            CID: null,
            CT: null
        };

        return payload;
    }

    getPageText = (text: string) => {
        if (!text) {
            return '';
        }

        const { widgetThemeVariables } = this.state;
        let textValue = text;

        if (widgetThemeVariables && Object.keys(widgetThemeVariables).length) {
            Object.keys(widgetThemeVariables).forEach((key: any) => {
               if (text.includes(key)) {
                   const variableValue = widgetThemeVariables[key];
                   const keyChunks = key.replace(/[^a-zA-Z0-9]/g,'_').split('_').filter((chunk: any) => chunk);
                   const lastChunk = keyChunks[keyChunks.length -1];           

                   if (lastChunk === 'link') {
                        textValue = textValue.replace(key, `<a href="${variableValue}" target="_blank">`);
                   } else if (lastChunk === 'end') {
                        textValue = textValue.replace(key, '</a>');
                   } else {
                        textValue = textValue.replace(key, variableValue);
                   }
               } 
            });
        }

        return textValue;
    };

    getThemeVariableKeyName = (str: string) => {
        const keyName = str.split(/(?=[A-Z])/).join('_').toLowerCase();
        const keyChunks = keyName.split('_');
        const lastKeyChunk = keyChunks[keyChunks.length -1];

        if (lastKeyChunk === 'link') {
            return [
                `\${${keyName}}`,
                `\${${keyName}_end}`
            ];
        }

        return `\${${keyName}}`;
    };

    getThemeVariables = () => {

        const { theme } = this.context;

        if (!theme) {
            return;
        }

        try {
            const { Meta } = theme;
            const widgetThemeVariables: any = {};
            const widgetThemeVariablesKeys = Object.keys(Meta).filter((key: any) => key.substr(0, 6) === 'Widget');

            widgetThemeVariablesKeys.forEach((key: string) => {
                const widgetKeyNames = this.getThemeVariableKeyName(key);

                if (Array.isArray(widgetKeyNames)) {
                    widgetKeyNames.forEach((keyName: string) => {
                        widgetThemeVariables[keyName] = Meta[key];
                    });
                } else {
                    widgetThemeVariables[widgetKeyNames] = Meta[key];
                }
            });

            this.setState({
                theme,
                widgetThemeVariables
            });
        } catch (e) {
            console.error(e);
        }
    };

    updateCaptcha = (value: string) => {
        this.setState({
            recaptcha: value,
            recaptchaError: false
        });
    };

    setRating = (typeID: number, valueID: number) => {
        const {
            reviewScheme: {
                RatingTypes,
                RatingValues
            }
        } = this.state;

        const RatingTypeItem: any = RatingTypes.find((item: any) => item.RatingTypeID === typeID);
        const RatingValueItem: any = RatingValues.find((item: any) => item.RatingValueID === valueID);

        const RatingTypeKeyName: string = RatingTypeItem ? RatingTypeItem.KeyName : null;
        const RatingValue: number = RatingValueItem ? RatingValueItem.Value : null;

        const rating: any = {
            RatingTypeID: typeID,
            RatingValueID: valueID,
            RatingTypeKeyName,
            RatingValue
        };

        const currentRatingIndex = this.state.payload.ReviewRating.findIndex((rating: any) => rating.RatingTypeID === typeID);

        if (currentRatingIndex === -1) {
            this.updatePayload('ReviewRating', [
                ...this.state.payload.ReviewRating,
                rating
            ]);
            return;
        }

        const currentRatings = this.state.payload.ReviewRating;
        currentRatings[currentRatingIndex] = rating;

        this.updatePayload('ReviewRating', currentRatings);
    };

    updatePayload = (key: string, value: any) => {

        if (key === 'ReviewerEmailAddress' && value?.length) {
            this.setState({showRecaptcha: true});
        }
        this.setState({
            payload: {
                ...this.state.payload,
                [key]: value
            }
        }, () => {
            if (key === 'ReviewRating') {
                if (value[value.length - 1].RatingTypeID === 6) {
                    this.clearError('ReviewRatingOverall');
                } else {
                    this.clearError(key);
                }
                return;
            }

            this.clearError(key);
        });
    };

    clearError = async (key: string) => {
        const { errors } = this.state;
        const validateErrors: any = await validateCreateReviewForm(this.state.payload);

        const isNotValid = validateErrors.find((error: any) => {
            return error.key === key;
        }) ? true : false;

        if (isNotValid) {
            return;
        }

        const element = document.getElementById(key);

        if (element) {
            element.classList.remove('is-invalid');
        }

        this.setState({
            errors: errors.filter((error: any) => error.key !== key)
        });
    };

    validate = async (): Promise<boolean> => {
        const errors = await validateCreateReviewForm(this.state.payload);

        if (errors.length === 0) {
            return true;
        }

        this.setState({
            errors
         }, () => this.processErrors());

        return false;
    };

    getReviewSchemes = async () => {

        const { memberData, domainOwnerID } = this.context;
        const memberCategories = memberData ? memberData.Categories : [];

        try {
            let reviewSchemes = JSON.parse(localStorage.getItem(TG_WIDGET_REVIEW_SCHEMES));

            if (!reviewSchemes || !reviewSchemes.length) {
                this.setState({ reviewSchemes: [] });
                return;
            }

            const memberCategoryIDs = memberCategories.map((item: any) => item.CategoryID);

            const reviewMemberCategoriesMap = new Map();
            reviewSchemes = reviewSchemes.filter((item: any) => {
                const reviewSchemeCategoryIDs = item.MemberCategory.map((mcItem: any) => mcItem.CategoryID);
                const intersection = reviewSchemeCategoryIDs.filter((rscItem: any) => memberCategoryIDs.includes(rscItem));
                reviewMemberCategoriesMap.set(item.ReviewSchemeID, intersection);
                return !!intersection.length;
            });

            if (!reviewSchemes.length) {
                throw new Error('Review Scheme with members not found');
            }

            const selReviewSchemeID = reviewSchemes[0].ReviewSchemeID;

            const updatedPayload: any = {
                ...this.state.payload,
                MemberID: Number(memberData.MemberID),
                Theme: getSiteName(),
                ReviewSchemeID: selReviewSchemeID            
            };

            if (domainOwnerID) {
                updatedPayload.DomainOwnerID = Number(domainOwnerID);
            }

            this.setState({ 
                reviewScheme: reviewSchemes[0],
                payload: updatedPayload,
                reviewSchemes
            });
        } catch (e) {
            console.error(e);
        }
    };

    renderReviewSchemeForReview = () => {
        const { reviewSchemes } = this.state;

        if (reviewSchemes.length < 2) {
            return '';
        }

        return (
            <div className="form-group">
                <div className="row">
                    <div className="col-12">
                        <div className="ml-3">
                            <p>Please choose the relevant 'Review Scheme' for this review</p>
                            <div className="kt-radio-list kt-radio-list--inline">
                                {
                                    reviewSchemes.map((scheme: any) => {
                                        return (
                                            <label className="kt-radio kt-radio--brand mr-4" key={scheme.ReviewSchemeID}>
                                                <input
                                                    type="radio"
                                                    name="ReviewSchemes"
                                                    value={scheme.ReviewSchemeID}
                                                    onChange={(e) => this.setReviewScheme(scheme)}
                                                    checked={Number(this.state.payload.ReviewSchemeID) === scheme.ReviewSchemeID}
                                                    className="mr-2"
                                                />
                                                {scheme.Name}
                                                <span></span>
                                            </label>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    setReviewScheme = (scheme: any) => {
        this.setState({
            reviewScheme: scheme,
            payload: {
                ...this.state.payload,
                ReviewSchemeID: scheme.ReviewSchemeID
            },
        }, () => this.loadData());
    };

    processErrors = () => {
        this.state.errors.forEach((error: any) => {
            const el = document.getElementById(error.key);

            if (el) {
                el.classList.add('is-invalid');
            }
        });
    };

    processServerSideErrors = () => {
        const errors: any = [];

        for (const error of this.state.serverSideErrors) {
            // Least-Surprise fail? Server side validation errors can return the Joi validation error message which will contain the DB column name
            // in question in double quotes. This is then extracted and used to create a link in the displayed message to the DOM element
            // in question on the assumption that the DB field name has a DOM element with the same id.

            // Check if any string appears in double quotes
            const isAnElementIdInTheMessage = this.regExIsFieldNameInErrorMessage.test(error);
            if (!isAnElementIdInTheMessage) {
                errors.push({
                    // Don't push an element id to the errors list (to stop the error text featuring as a link)
                    message: error
                });
                break;
            }

            const errorElementID = error.match(this.regExIsFieldNameInErrorMessage)[1];
            errors.push({
                elementID: errorElementID,
                // Add spaces between the words of the pascal-cased DB field name (which is expected to also be a DOM element id)
                message: error.replace(`"${errorElementID}"`, errorElementID.replace(/([A-Z])/g, ' $1').trim())
            });
        }

        this.setState({
            errors
        });
    };

    renderErrors = () => {
        const { errors } = this.state;

        if (!errors.length) {
            return '';
        }

        return (
            <div className="alert alert-danger pl-0 error-box">
                <ul className="mb-0">
                    {
                        errors.map((error: any, key: number) => {
                            return (
                                <li key={key}>
                                    {
                                        error.elementID === undefined ?
                                            <span className="d-block mb-2">
                                                {error.message}
                                            </span>
                                            :
                                            <span className="error-link d-block mb-2" onClick={() => this.scrollToError(error.elementID)}>
                                                {error.message}
                                            </span>
                                    }
                                </li>
                            );
                        })
                    }
                </ul>
            </div>
        );
    };

    getUrlParam(key: string) {
        const url = window.location.href;
        const urlChunks = url.split('/');

        if (!urlChunks.includes(key)) return null;

        const segmentIndex = urlChunks.findIndex((part: string) => part === key);

        return urlChunks[(segmentIndex + 1)].split('?')[0];
    }

    createReview = async (e: any) => {
        e.preventDefault();

        if (this.state.submitting || !await this.validate()) {
            return;
        }

        this.setState({ submitting: true });

        if (!this.state.recaptcha) {
            this.setState({
                recaptchaError: true,
                submitting: false
            });
            return;
        }

        try {
            const payload = { ...this.state.payload };

            const {
                queryParams: {
                    rs
                }
            } = this.context;

            if (rs) {
                payload.ReferrerSource = rs;
            }

            const sourceID = this.getUrlParam('sourceid');
            const campaignID = this.getUrlParam('campaignid');

            if (sourceID && !isNaN(Number(sourceID))) {
                payload.CollectionSourceID = Number(sourceID.replace(/[^a-zA-Z0-9 ]/g, ''));
            }

            if (campaignID && !isNaN(Number(campaignID))) {
                payload.CampaignID = Number(campaignID.replace(/[^a-zA-Z0-9 ]/g, ''));
            }

            await createReview(payload);

            this.setState({
                success: true
            });
        } catch (e) {
            const err: any = e;
            console.error(err);
            this.setState({
                serverSideErrors: err?.data.errors
            }, () => this.processServerSideErrors());
        } finally {
            this.setState({
                submitting: false
            });
        }
    };

    scrollToError = (elementID: string) => {
        const element = document.getElementById(elementID);

        if (!element) {
            return;
        }

        element.focus();
    };

    renderTitle = () => {
        const { memberData } = this.context;

        if (!memberData) {
            return <h1 className="portlet__head-title pt-5"><strong>Write a review</strong></h1>;
        }

        const { Name } = memberData;

        return (
            <div>
                <h1 className="portlet__head-title mb-4"><strong>Write a review for { Name }</strong></h1>
                <p className="portlet__head-title mb-3">
                    <PageText text={this.state.pageMeta.WidgetIntroduction} />
                </p>
            </div>
        );
    };
    
    renderAddress = () => {
        const { memberData } = this.context;

        const {
            Address1,
            Address2,
            PostalCode,
            RegionCode
        } = memberData;

        return <p>{ Address1 }, { Address2 ? `${Address2}, ` : '' } { RegionCode || '' } { PostalCode || '' } </p>;
    };

    reviewContentCount = () => {
        const reviewContentEl: any = document.getElementById('ReviewContent');

        if (!reviewContentEl) {
            return;
        }

        return reviewContentEl.value.length;
    };

    registerStarSymbol = () => {
        return (
            <div className="d-none">
                <svg>
                    <symbol id="star" viewBox="0 0 28 28" preserveAspectRatio="xMaxYMax meet">
                        <title>Star Rating</title>
                        <path
                            className="star"
                            d="M13.996,22.501 L22.649,27.997 L20.352,17.637 L27.996,10.667 L17.930,9.768 L13.996,-0.003 L10.063,9.768 L-0.003,10.667 L7.641,17.637 L5.345,27.997 L13.996,22.501 Z"
                        />
                    </symbol>
                </svg>
            </div>
        );
    };

    checkActiveTypeValue = (typeID: number, value: any) => {
        const { typeValues } = this.state;

        if (value === null) {
            return typeValues[typeID] === value;
        }

        if (!typeValues[typeID]) {
            return false;
        }

        return typeValues[typeID] >= value;
    };

    setTypeValueAndRating = (typeID: number, value: any, valueID: number) => {
        const { typeValues } = this.state;

        if (typeValues[typeID] && typeValues[typeID] === value) {
            this.removeRating(typeID);
            return;
        }

        this.setState({
            typeValues: {
                ...this.state.typeValues,
                [typeID]: value
            }
        }, () => this.setRating(typeID, valueID));
    };

    removeRating = (typeID: number) => {
        const reviewRating = this.state.payload.ReviewRating;
        const index = reviewRating.findIndex((rr: any) => rr.RatingTypeID === typeID);

        const typeValues = this.state.typeValues;
        delete typeValues[typeID];

        reviewRating.splice(index, 1);

        this.setState({
            payload: {
                ...this.state.payload,
                ReviewRating: reviewRating
            }
        });
    };

    renderPortletGroups = () => {
        return this.state.portletGroups.map((portlet: string, key: number) => {
            if (typeof(this[portlet as keyof CreateReview]) === 'function') {
                return this[portlet as keyof CreateReview](key);
            } else {
                return false;
            }
        });
    };

    setNARatingID = async () => {
        const { reviewScheme } = this.state;

        if (!reviewScheme) {
            return;
        }

        const naRatingValue = reviewScheme.RatingValues.find((value: any) => !value.Value);

        this.setState({
            naRatingValue
        });
    };

    setInitialOverallRating = (initRating: number) => {
        const OVERALL_RATING_TYPE_ID = 6;
        const { RatingTypes, RatingValues } = this.state.reviewScheme;
        
        if (!RatingTypes) {
            console.error('Failed to get RatingTypes');
        }

        if (!RatingValues) {
            console.error('Failed to get RatingValues');
        }

        const ratingValue = RatingValues.find((ratingValue: any) => ratingValue.Value === initRating);

        if (ratingValue) {
            this.setTypeValueAndRating(OVERALL_RATING_TYPE_ID, ratingValue.Value, ratingValue.RatingValueID);
        }
    };

    async componentDidMount () {
        await this.getReviewSchemes();
        await this.loadData();

        const { queryParams, auth } = this.context;
        if (queryParams.inviteToken) {
            this.updatePayload('InviteToken', queryParams.inviteToken);
        }      

        if (queryParams.overallRatingValue) {
            this.setInitialOverallRating(queryParams.overallRatingValue);
        }      
        
        if (auth.websiteUserID) {
            this.updatePayload('WebsiteUserID', auth.websiteUserID);
        }

        if (queryParams.firstName) {
            this.updatePayload('ReviewerFirstName', queryParams.firstName);
        } 

        if (queryParams.lastName) {
            this.updatePayload('ReviewerLastName', queryParams.lastName);
        } 

        if ((queryParams.firstName || {}).length && (queryParams.lastName || {}).length) {

            const displayName = `${queryParams.firstName} ${queryParams.lastName.charAt(0)}`;
            this.updatePayload('ReviewerDisplayName' ,displayName);
        }

        if (queryParams.emailAddress) {
            this.updatePayload('ReviewerEmailAddress', queryParams.emailAddress);
        }

        if (queryParams.cid) {
            this.updatePayload('CID', queryParams.cid);
        }

        if (queryParams.ct) {
            this.updatePayload('CT', queryParams.ct);
        }

        this.setState({
            loading: false
        });
    }

    loadData = async () => {
        try {
            this.setState({ loading: true });
            this.getThemeVariables();
            this.setNARatingID();
            this.setState({ loading: false });
        } catch (e) {
            console.error(e);
        }
    };

    handleRatingErrors = (typeID: number, key?: string) => {
        const { errors, typeValues } = this.state;
        const ratingError = errors.find((error: any) => error.key === key || 'ReviewRating');

        if (!ratingError) {
            return null;
        }

        if (typeValues[typeID]) {
            return null;
        }

        return {
            error: ratingError
        };
    };

    // Render function start

    renderContactDetails = (key: number) => {
        return (
            <div className="form-group" key={`group-${key}`}>
                <div className="row">
                    <div className="col-md-7">
                        <PageText text={this.getPageText(this.state.pageMeta.WidgetContactDetailsDescription)} />
                    </div>
                </div>
            </div>
        );
    };

    renderFirstName = (key: number) => {

        const { payload } = this.state;

        return (
            <div className="form-group" key={`group-${key}`}>
                <div className="row">
                    <div className="col-md-7">
                        <label htmlFor="ReviewerFirstName">Your first name</label>
                        <input
                            type="text"
                            id="ReviewerFirstName"
                            className="form-control"
                            value={payload.ReviewerFirstName || ''}
                            onChange={(e) => this.updatePayload('ReviewerFirstName', (e.target as any).value)}
                            onBlur={(e :any) => this.setDisplayName ? this.setDisplayName(e.target) : null }
                            placeholder="John"
                        />
                    </div>
                </div>
            </div>
        );
    };

    renderLastName = (key: number) => {

        const { payload } = this.state;

        return (
            <div className="form-group" key={`group-${key}`}>
                <div className="row">
                    <div className="col-md-7">
                        <label htmlFor="ReviewerLastName">Your last name</label>
                        <input
                            type="text"
                            id="ReviewerLastName"
                            className="form-control"
                            value={payload.ReviewerLastName || ''}
                            onChange={(e) => this.updatePayload('ReviewerLastName', (e.target as any).value)}
                            onBlur={(e :any) => this.setDisplayName ? this.setDisplayName(e.target) : null }
                            placeholder="Smith"
                        />
                    </div>
                </div>
            </div>
        );
    };

    renderEmailAddress = (key: number) => {

        const { payload } = this.state;

        return (
            <div className="form-group" key={`group-${key}`}>
                <div className="row">
                    <div className="col-md-7">
                        <label htmlFor="ReviewerEmailAddress">Your email address</label>
                        <input
                            type="text"
                            id="ReviewerEmailAddress"
                            className="form-control"
                            value={payload.ReviewerEmailAddress || ''}
                            onChange={(e) => this.updatePayload('ReviewerEmailAddress', (e.target as any).value)}
                            placeholder="john.smith@gmail.com"
                        />
                    </div>
                </div>
            </div>
        );
    };

    renderTelephone = (key: number) => {
        return (
            <div className="form-group" key={`group-${key}`}>
                <div className="row">
                    <div className="col-md-7">
                        <label htmlFor="ReviewerTelephoneNumber">Your phone number</label>
                        <input
                            type="tel"
                            id="ReviewerTelephoneNumber"
                            className="form-control"
                            onChange={(e) => this.updatePayload('ReviewerTelephoneNumber', (e.target as any).value)}
                            placeholder="(917) 251-3398"
                        />
                    </div>
                </div>
            </div>
        );
    };

    renderExperienceTypes = (key: number) => {
        const experienceTypes = this.state.reviewScheme.ExperienceTypes;
        const options = experienceTypes.map((et: any) => {
            return {
                value: et.ExperienceTypeID,
                label: et.Name
            };
        });

        return (
            <div key={`group-${key}`}>
                <div className="form-group no-outline-focus ui-select-group" id="ExperienceTypeID" tabIndex={0}>
                    <div className="row">
                        <div className="col-md-7">
                            <label htmlFor="ExperienceTypeID">What is your connection to this community?</label>
                            <p>
                                <PageText
                                    text={this.getPageText(this.state.pageMeta.WidgetExperienceDescription)}
                                />
                            </p>
                            <ReactDropdown
                                onChange={(selectedOption) => { 
                                    this.updatePayload('ExperienceTypeID', (selectedOption as any).value);
                                }}
                                options={options}
                                className="ui-select"
                            />
                        </div>
                    </div>
                </div>
                { this.renderConnection() }
            </div>
        );
    };

    renderConnection = () => {
        const experienceTypeID = this.state.payload.ExperienceTypeID;
        const reviewerConnections = this.state.reviewScheme.ReviewerConnections;

        if (!experienceTypeID) {
            return '';
        }

        if (Number(experienceTypeID) !== 4) {
            return '';
        }

        const options = reviewerConnections.map((rc: any) => {
            return {
                value: rc.ReviewerConnectionID,
                label: rc.Name
            };
        });

        return (
            <div className="form-group no-outline-focus ui-select-group" key={'group-connection'} id="ReviewerConnectionID" tabIndex={0}>
                <div className="row">
                    <div className="col-md-7 ">
                        <label htmlFor="ReviewerConnectionID">Your relationship to the resident or client</label>
                        <ReactDropdown
                            onChange={(selectedOption) => {
                                this.updatePayload('ReviewerConnectionID', (selectedOption as any).value);
                            }}
                            options={options}
                            className="ui-select"
                        />
                    </div>
                </div>
            </div>
        );
    };

    renderMemberCategories = (key: number) => {
        const { memberData } = this.context;

        const { reviewScheme } = this.state;
        const memberCategoryIDs = memberData.Categories.map((item: any) => item.CategoryID);
        let displayedMemberCategories = [];

        const reviewSchemeCategories = (reviewScheme || {}).MemberCategory || [];

        displayedMemberCategories = reviewSchemeCategories.filter((rscItem: any) => memberCategoryIDs.includes(rscItem.CategoryID));

        if (displayedMemberCategories.length === 0) {
            return null;
        }

        if (displayedMemberCategories.length === 1) {
            this.state.payload.MemberCategoryID = displayedMemberCategories[0].CategoryID;
            return null;
        }

        const error = this.state.errors.find((error: any) => error.key === 'MemberCategoryID');

        return (
            <div className="form-group" key={`group-${key}`}>
                <label className={error ? 'text-danger' : ''}>Which category of care is best suited to the person receiving care in this review?</label>
                <p className="mb-0">
                    <PageText text={this.getPageText(this.state.pageMeta.WidgetCategoryOfCareDescription)} />
                </p>
                <div className="kt-radio-list kt-radio-list--inline d-flex mb-4">
                    {
                        displayedMemberCategories.map((cat: any) => {
                            return (
                                <label className="kt-radio kt-radio--brand mr-3 d-flex align-items-center" key={cat.CategoryID}>
                                    <input
                                        id='MemberCategoryID'
                                        type="radio"
                                        name="MemberCategory"
                                        value={cat.CategoryID}
                                        onChange={(e) => this.updatePayload('MemberCategoryID', Number((e.target as any).value))}
                                        className="mr-2"
                                    />
                                    { cat.Name }
                                    <span></span>
                                </label>
                            );
                        })
                    }
                </div>
            </div>
        );
    };

    renderYourReviewAndRating = (key: number) => {
        const { WidgetReviewAndRatingDescription } = this.state.pageMeta;

        if (!WidgetReviewAndRatingDescription) {
            return '';
        }

        return (
            <div className="form-group" key={`group-${key}`}>
                <div className="row">
                    <div className="col-md-6">
                        <PageText text={this.getPageText(this.state.pageMeta.WidgetReviewAndRatingDescription)} />
                    </div>
                </div>
            </div>
        );
    };

    renderDisplayName = (key: number) => {
        return (
            <div className="form-group" key={`group-${key}`}>
                <div className="row">
                    <div className="col-md-7 ">
                        <label htmlFor="ReviewerDisplayName">Name that will appear on review</label>
                        <p>
                            <PageText text={this.getPageText(this.state.pageMeta.WidgetDisplayNameDescription)} />
                        </p>
                        <input
                            type="text"
                            className="form-control"
                            onChange={(e) => {
                                this.updatePayload('ReviewerDisplayName', (e.target as any).value);
                                if (this.setDisplayNameManuallySet) {
                                    console.log('setDisplayNameManuallySet');
                                    this.setDisplayNameManuallySet();
                                }
                            }}
                            id="ReviewerDisplayName"
                            value={this.state.payload.ReviewerDisplayName || ''}
                            
                        />
                    </div>
                </div>
            </div>
        );
    };

    renderReviewTitle = (key: number) => {
        return (
            <div className="form-group" key={`group-${key}`}>
                <div className="row">
                    <div className="col-md-7">
                        <label htmlFor="ReviewTitle">Title of your review</label>
                        <p className="mb-0">
                            <PageText text={this.getPageText(this.state.pageMeta.WidgetReviewTitle)} />
                        </p>
                        <input
                            type="text"
                            className="form-control"
                            onChange={(e) => this.updatePayload('ReviewTitle', (e.target as any).value)}
                            id="ReviewTitle"
                            placeholder="Summarize your experience"
                        />
                    </div>
                </div>
            </div>
        );
    };

    renderReviewContent = (key: number) => {
        return (
            <div className="form-group" key={`group-${key}`}>
                <div className="row">
                    <div className="col-md-7">
                        <div className="row">
                            <div className="col-sm-6">
                                <label htmlFor="ReviewContent" className="m-0">Your review</label>
                            </div>
                            <div className="col-sm-6 text-right">
                                <a
                                    className="text-primary cursor-pointer"
                                    onClick={() => this.setState({ showTopTips: true })}
                                >
                                    Top Tips for Writing a Review
                                </a>
                            </div>
                        </div>
                        <p>A <strong>minimum of 200 characters</strong> and max of 1,000 characters required.</p>
                        <textarea
                            name="ReviewContent"
                            id="ReviewContent"
                            cols={30}
                            rows={15}
                            maxLength={1000}
                            className="form-control"
                            onChange={(e) => {
                                if ((e.target as any).value && (e.target as any).value.length > 1000) return;

                                this.updatePayload('ReviewContent', (e.target as any).value);
                            }}
                            placeholder="Tell others about your experience"
                            
                        ></textarea>
                    </div>
                    <div className="col-md-5 review-content-side-text">
                        <p>
                            Currently <strong>{ this.reviewContentCount() ? this.reviewContentCount() : 0 }</strong> characters
                        </p>
                        <PageText text={this.getPageText(this.state.pageMeta.WidgetReviewContentDescription)} />
                    </div>
                </div>
            </div>
        );
    };

    renderCost = (key: number) => {
        return (
            <div className="form-group" key={`group-${key}`}>
                <div className="row d-none">
                    <div className="col-md-7">
                        <label htmlFor="Cost">Cost</label>
                        <p>Based on the level of care required by you or your loved one. Will not be displayed with your review.</p>
                    </div>
                </div>
                <div className="row d-none">
                    <div className="col-md-2 input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">$</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            onChange={(e) => this.updatePayload('Cost', (e.target as any).value)}
                            id="Cost"
                        />
                        <div className="input-group-append">
                            <span className="input-group-text">.00</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    renderRatings = (ratingTypes: any, showLabels: boolean, isOverall?: boolean) => {
        const {
            naRatingValue,
            reviewScheme,
        } = this.state;

        return <FullStars
            naRatingValue={naRatingValue}
            reviewScheme={reviewScheme}
            ratingTypes={ratingTypes}
            setTypeValueAndRating={this.setTypeValueAndRating}
            checkActiveTypeValue={this.checkActiveTypeValue}
            showLabels={showLabels}
            error={this.handleRatingErrors}
            isOverallRating={isOverall || false}
        />;
    };

    renderOverallRating = (key: number) => {
        const { RatingTypes } = this.state.reviewScheme;
        const ratingTypes = RatingTypes.filter((type: any) => type.KeyName === 'overall');
        const overallRating = this.state.payload.ReviewRating.find((rating: any) => rating.RatingTypeID === 6);
        const ratingError = this.handleRatingErrors(overallRating ? overallRating.RatingTypeID : null);

        return (
            <div className="form-group no-outline-focus" id="ReviewRatingOverall" tabIndex={0} key={`group-${key}`}>
                <div className="row">
                    <div className="col">
                        <label
                            htmlFor="OverallRating"
                            className={`${ratingError ? 'text-danger' : ''}`}
                        >
                            How would you rate your overall experience with this community?
                            {
                                ratingError
                                ?
                                <img className="overall-rating-error ml-2" src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23F64E60' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23F64E60' stroke='none'/%3e%3c/svg%3e" alt=""/>
                                : ''
                            }
                        </label>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-7">
                        <PageText text={this.getPageText(this.state.pageMeta.WidgetOverallRatingDescription)} />
                        <div className="overall-rating-display">
                            <span className="review-star-rating__type">Overall Experience</span>
                            { this.renderRatings(ratingTypes, false, true) }
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    renderOtherRatings = (key: number) => {
        const { RatingTypes } = this.state.reviewScheme;
        const ratingTypes = RatingTypes.filter((type: any) => type.KeyName !== 'overall');

        return (
            <div className="form-group no-outline-focus" id="ReviewRating" tabIndex={0} key={`group-${key}`}>
                <div className="row">
                    <div className="col-md-7">
                        <label htmlFor="OtherRatings">How would you rate the community on the following?</label>
                        <p className="mb-0">
                            <PageText text={this.getPageText(this.state.pageMeta.WidgetOtherRatingsDescription)} />
                        </p>
                        { this.renderRatings(ratingTypes, true) }
                    </div>
                </div>
            </div>
        );
    };

    renderTermsAndCondition = (key: number) => {
        const error = this.state.errors.find((error: any) => error.key === 'Terms');
        return (
            <div className="form-group" key={`group-${key}`}>
                <div className="row mt-4">
                    <div className="col-md-7">
                        <div className="form-check">
                            <input
                                className={`form-check-input form-check-input-review ${error ? 'is-invalid' : ''}`}
                                type="checkbox"
                                id="Terms"
                                onChange={() => this.clearError('Terms')}
                            />
                            <label className={`form-check-label non-bold ml-1 d-inline label--sm ${error ? 'text-danger' : ''}`} htmlFor="Terms">
                                I certify this is my genuine opinion and in submitting it I 
                                agree to the
                            </label>
                            &nbsp;
                            <a
                                className="label--sm"
                                href={this.state.theme.Meta.WidgetTermsAndConditionsLink}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Terms of Use
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    renderRecaptcha = (key: number) => {

        if (!this.state.showRecaptcha) {
            return null;
        }

        return (
            <div className="form-group" key={`group-${key}`}>
                <div className="row">
                    <div className="col-md-12">
                    <ReCAPTCHA
                        sitekey="6Lcbpe0UAAAAAHsJsXEcaUjIKs6JSeDdGa3lCgL9"
                        onChange={this.updateCaptcha}
                    />
                    { this.state.recaptchaError ?
                        <p className="invalid-feedback mb-0 mt-4">Please complete the reCAPTCHA</p>
                        : ''  
                    }
                    </div>
                </div>
            </div>
        );
    };

    setDisplayNameManuallySet = () =>{
        this.setState({
            displayNameManuallySet : true
        });
    };

    setDisplayName = (target : any) =>{
        if(!this.state.displayNameManuallySet){
            if(target.id === 'ReviewerFirstName'){
                let lastNameInitial = this.state.payload.ReviewerDisplayName ? this.state.payload.ReviewerDisplayName.split(' ')[1] ? this.state.payload.ReviewerDisplayName.split(' ')[1].substr(1) : '' : '';

                if (!lastNameInitial.length) {
                    lastNameInitial = this.state.payload.ReviewerDisplayName ? this.state.payload.ReviewerDisplayName.trim().length === 1 ? this.state.payload.ReviewerDisplayName.trim() : '' : '';
                }

                this.updatePayload('ReviewerDisplayName',  `${target.value} ${lastNameInitial}`);
            }

            if (target.id === 'ReviewerLastName') {
                const firstName = this.state.payload.ReviewerDisplayName.split(' ')[0];
                this.updatePayload('ReviewerDisplayName', `${firstName} ${target.value.substr(0,1)}`);
            }
        }
    };

    // Render functions end

    renderLogo = () => {

        const { branding } = this.context;

        if (!branding) {
            return '';
        }

        const { Logo, SiteName } = branding;

        return <img src={Logo} className={`logo-${SiteName}`} alt={`${SiteName}-logo`} />;
    };

    renderSuccess = () => {
        const { memberData, branding } = this.context;

        const {
            ProfileURL,
            Name
        } = memberData;

        const { Website } = branding;
        const profileURL = getSiteName() === 'sa' ? Website : ProfileURL;
        const btnText = getSiteName() === 'sa' ? 'Return to Home Page' : `Return to ${Name}`;

        return (
            <div className="portlet create-review-success">
                <div className="container">
                    <div className="portlet__body px-0">
                        { this.renderLogo() }
                        <h3 className="mt-4">
                            <PageText text={this.getPageText(this.state.pageMeta.WidgetConfirmationMessage)} />
                        </h3>
                        {
                            profileURL
                            ?
                            <a href={profileURL} id="return-link" className="btn btn-brand mt-4">
                                { btnText }
                            </a>
                            :
                            ''
                        }
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const {
            loading,
            success,
            submitting,
            showTopTips
        } = this.state;

        if (loading) {
            return '';
        }

        const { memberData } = this.context;

        if (!memberData) {
            return '';
        }

        if (success) {
            return this.renderSuccess();
        }

        if (loading) {
            return '';
        }

        return (
            <div>
                { this.registerStarSymbol() }
                <Header />
                <div className="portlet create-review-form">
                    <form onSubmit={this.createReview}>
                        <div className="portlet__body px-0">
                            <div className="create-review-container container">
                                <div className="row">
                                    <div className="col-sm-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                                        { this.renderTitle() }
                                        { this.renderReviewSchemeForReview() }
                                        { this.renderPortletGroups() }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                                        { this.renderErrors() }
                                        {
                                            submitting
                                            ?
                                            <div className="kt-spinner kt-spinner--md kt-spinner--info"></div>
                                            :
                                            <button className="btn btn-brand" type="submit">Submit review</button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                { showTopTips ? <TopTips handleClose={() => this.setState({ showTopTips: false })} /> : <></> }
            </div>
        );
    }
}

CreateReview.contextType = StorageContext;

export default CreateReview;
